import { P2GBox, P2GText, P2GGrid } from '@parcel2go/core-ui';
import { LayoutIndent } from '../../lib/consts/LayoutConstants';
import { FixedColumn } from '../FixedColumn';
import { AppCard } from '~/components/card/app-card';
import QuickToggleAll from './quickselect/QuickToggleAll';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';

interface props {
  selected: number;
  total: number;
  filterKey: string;
}

export default function SmartSendListyHeaderRow(props: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const p = 1;

  return (
    <AppCard>
      <P2GBox pl={1} pr={1}>
        <FixedColumn
          alignItems="center"
          right={
            <P2GGrid container spacing={1} alignItems="center">
              <P2GGrid item xs={12} sm={4}>
                <P2GBox p={p}>
                  <P2GText colour="primary">
                    <strong>{t('MY_ORDERS_TABLE_HEADER_ORDER_DETAILS', { defaultValue: 'Order Details' })}</strong>
                  </P2GText>
                </P2GBox>
              </P2GGrid>
              <P2GGrid item xs={12} sm={3}>
                <P2GBox p={p}>
                  <P2GText colour="primary">
                    <strong>{t('MY_ORDERS_TABLE_HEADER_CUSTOMER', { defaultValue: 'Customer' })}</strong>
                  </P2GText>
                </P2GBox>
              </P2GGrid>
              <P2GGrid item xs={12} sm={5}>
                <P2GBox p={p}>
                  <P2GText colour="primary">
                    <strong>
                      {t('MY_ORDERS_TABLE_HEADER_SERVICE_TRACKING_NUMBER', {
                        defaultValue: 'Service / Tracking Number'
                      })}
                    </strong>
                  </P2GText>
                </P2GBox>
              </P2GGrid>
            </P2GGrid>
          }
          left={<QuickToggleAll selected={props.selected} total={props.total} filterKey={props.filterKey} />}
          width={LayoutIndent}
        />
      </P2GBox>
    </AppCard>
  );
}
